import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { locations } from "../data/locations";

const ServiceAreas = () => {
  return (
    <section
      id="werkgebied"
      className="py-24 bg-white"
      aria-labelledby="werkgebied-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-4">
            Ons Werkgebied
          </span>
          <h2
            id="werkgebied-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4"
          >
            Glazenwasser in uw plaats
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Cleven Cleaning is actief in Rosmalen, Den Bosch en de omliggende
            kernen. Bekijk de pagina van uw plaats voor lokale informatie.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {locations.map((loc) => (
            <Link
              key={loc.slug}
              to={`/glazenwasser-${loc.slug}`}
              data-testid={`service-area-link-${loc.slug}`}
              className="group flex items-center justify-between gap-3 bg-gradient-to-br from-slate-50 to-sky-50 rounded-2xl p-5 border border-slate-100 hover:border-sky-300 hover:shadow-lg transition-all"
            >
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-sky-500 to-teal-500 flex items-center justify-center shadow-md shadow-sky-500/20">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="font-bold text-slate-800 group-hover:text-sky-600 transition-colors">
                    Glazenwasser {loc.name}
                  </p>
                  <p className="text-sm text-slate-500">{loc.region}</p>
                </div>
              </div>
              <ArrowRight className="w-5 h-5 text-slate-400 group-hover:text-sky-500 group-hover:translate-x-1 transition-all flex-shrink-0" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
